import { getReq, postReq } from "./api.js";
const BASE = "crm";

// ── Users ─────────────────────────────────────────────

/**
 * Fetch all active users (for "Assigned To" dropdown)
 * GET /api/crm/users
 */
export const fetchUsers = async () => {
  const { data } = await getReq(`${BASE}/users`);
  return data; // array of { _id, name, email, avatar }
};

// ── Requirements ──────────────────────────────────────

/**
 * Fetch all requirements grouped by column
 * GET /api/crm/requirements
 * Returns: { requirement: [], in_discussion: [], business_conversion: [] }
 */
export const fetchRequirements = async () => {
  const { data } = await getReq(`${BASE}/requirements`);
  return data;
};

/**
 * Create a new requirement
 * POST /api/crm/requirements
 * Body: { jobName, region, projectValue, duration, hourlyRate?, assignedTo }
 */
export const createRequirement = async (payload) => {
  const { data } = await postReq(`${BASE}/requirements`, payload);
  return data;
};

/**
 * Update requirement fields
 * PUT /api/crm/requirements/:id
 */
export const updateRequirement = async (id, payload) => {
  const { data } = await postReq(`${BASE}/requirements/${id}`, payload);
  return data;
};

/**
 * Move a card to a different column
 * PATCH /api/crm/requirements/:id/column
 * Body: { column: "in_discussion" | "business_conversion" | "requirement" }
 */
export const moveRequirementColumn = async (id, column) => {
  const { data } = await postReq(`${BASE}/requirements/${id}/column`, {
    column,
  });
  return data;
};

/**
 * Soft delete a requirement
 * DELETE /api/crm/requirements/:id
 */
export const deleteRequirement = async (id) => {
  const { data } = await postReq(`${BASE}/requirements/${id}/delete`);
  return data;
};

// ── Messages ──────────────────────────────────────────

/**
 * Fetch messages for a requirement (paginated)
 * GET /api/crm/requirements/:id/messages?page=1&limit=50
 */
export const fetchMessages = async (requirementId, page = 1, limit = 50) => {
  const { data } = await getReq(
    `${BASE}/requirements/${requirementId}/messages`,
    { params: { page, limit } },
  );
  return data; // { data: messages[], pagination: {} }
};

/**
 * Send a message in a requirement conversation
 * POST /api/crm/requirements/:id/messages
 * Body: { text }
 */
export const sendMessage = async (requirementId, text) => {
  const { data } = await postReq(
    `${BASE}/requirements/${requirementId}/messages`,
    { text },
  );
  return data; // the new message object
};

/**
 * Delete own message
 * DELETE /api/crm/requirements/:id/messages/:messageId
 */
export const deleteMessage = async (requirementId, messageId) => {
  const { data } = await postReq(
    `${BASE}/requirements/${requirementId}/messages/${messageId}`,
  );
  return data;
};

export const updateDescription = async (id, description) => {
  const { data } = await postReq(`${BASE}/requirements/${id}/description`, {
    description,
  });
  return data;
};

export const fetchUnreadCounts = async () => {
  const { data } = await getReq(`${BASE}/messages/unread-counts`);
  return data; // { "reqId1": 3, "reqId2": 1, ... }
};
